var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrapper"},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isLoading}}),_c('img',{attrs:{"src":_vm.imageSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }